<template>

    <div class="config-details-container">
        <div v-if="selectedView">

            <div class="view-details-container" style="padding: 15px; width: 325px;">
                <span class="label">General</span>
                <div class="config-name">
                    <v-form ref="viewNameForm" v-model="viewNameFormValid" :lazy-validation="true">
                        <v-text-field v-model="selectedViewClone.view_name" label="Geo Map View Name" color="#c42111" :disabled="!userOwnsSelectedView" :rules="[validation.required(selectedViewClone.view_name, 'View Name'), validation.unique(selectedViewClone.view_name, $props.mapViews, $store.state.user.user_id)]">
                            <template v-slot:append>
                                <v-btn color="#4caf50" icon @click="saveViewNameClick"><v-icon>mdi-content-save</v-icon></v-btn>
                            </template>
                        </v-text-field>
                    </v-form>
                </div>
                <div class="mt-4" style="position: relative;">
                    <v-img class="map-theme-image" :src="$props.googleMapStylesThumbnails[selectedView.view_grid_config.generalSettings.mapTheme]" />
                    <span class="map-theme-text">{{ mapThemes.find(t => t.value == selectedView.view_grid_config.generalSettings.mapTheme).text }}</span>
                </div>
            </div>

            <div class="view-details-container" style="padding: 15px;">
                <span class="label">Thumbnail</span>
                <div class="geomap-view-thumbnail-container">

                    <div class="map-container" :class="{empty: !staticMapImgUrl}">
                        <img :src="staticMapImgUrl" v-if="staticMapImgUrl" />
                        <div class="empty-map-container" v-if="!staticMapImgUrl">
                            <v-icon class="no-map-image-icon">mdi-map-marker-off</v-icon>
                            <span class="no-map-text">No Map Image Available.</span>
                        </div>
                    </div>

                </div>
            </div>

            <div class="view-details-container view-details-site-filters">
                <span class="label">Site Filters</span>
                <div class="left-container">
                    <div class="severity-container">
                        <span class="type-label">Sites</span>
                        <v-icon :color="geoColors.critical.background" :class="{disabled: !selectedView.view_grid_config.siteAlarmFilters.critical}">{{selectedView.view_grid_config.siteAlarmFilters.critical ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon :color="geoColors.major.background" :class="{disabled: !selectedView.view_grid_config.siteAlarmFilters.major}">{{selectedView.view_grid_config.siteAlarmFilters.major ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon :color="geoColors.minor.background" :class="{disabled: !selectedView.view_grid_config.siteAlarmFilters.minor}">{{selectedView.view_grid_config.siteAlarmFilters.minor ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon :color="geoColors.observational.background" :class="{disabled: !selectedView.view_grid_config.siteAlarmFilters.observational}">{{selectedView.view_grid_config.siteAlarmFilters.observational ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon :color="geoColors.normal.background" :class="{disabled: !selectedView.view_grid_config.siteAlarmFilters.normal}">{{selectedView.view_grid_config.siteAlarmFilters.normal ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon color="#c42111" style="margin-right: 0px; font-size: 30px" :class="{disabled: !selectedView.view_grid_config.siteAlarmFilters.serviceAffecting}">{{selectedView.view_grid_config.siteAlarmFilters.serviceAffecting ? 'mdi-checkbox-blank' : 'mdi-checkbox-blank-off'}}</v-icon>
                    </div>
                    <div class="severity-container">
                        <span class="type-label">Links</span>
                        <v-icon :color="geoColors.critical.background" :class="{disabled: !selectedView.view_grid_config.linkAlarmFilters.critical}">{{selectedView.view_grid_config.linkAlarmFilters.critical ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon :color="geoColors.major.background" :class="{disabled: !selectedView.view_grid_config.linkAlarmFilters.major}">{{selectedView.view_grid_config.linkAlarmFilters.major ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon :color="geoColors.minor.background" :class="{disabled: !selectedView.view_grid_config.linkAlarmFilters.minor}">{{selectedView.view_grid_config.linkAlarmFilters.minor ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon :color="geoColors.observational.background" :class="{disabled: !selectedView.view_grid_config.linkAlarmFilters.observational}">{{selectedView.view_grid_config.linkAlarmFilters.observational ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon :color="geoColors.normal.background" :class="{disabled: !selectedView.view_grid_config.linkAlarmFilters.normal}">{{selectedView.view_grid_config.linkAlarmFilters.normal ? 'mdi-bell' : 'mdi-bell-off'}}</v-icon>
                        <v-icon color="#c42111" style="margin-right: 0px; font-size: 30px" :class="{disabled: !selectedView.view_grid_config.linkAlarmFilters.serviceAffecting}">{{selectedView.view_grid_config.linkAlarmFilters.serviceAffecting ? 'mdi-checkbox-blank' : 'mdi-checkbox-blank-off'}}</v-icon>
                    </div>
                </div>
                <div class="right-container">
                    <div class="count-container">
                        <span class="count">{{selectedView.view_grid_config.siteTagFilters.length}}</span>
                        <v-icon>mdi-tag-multiple</v-icon>
                    </div>
                    <div class="count-container">
                        <span class="count">{{selectedView.view_grid_config.siteTechnicianFilters.length}}</span>
                        <v-icon>mdi-account</v-icon>
                    </div>
                    <div class="count-container">
                        <span class="count">{{selectedView.view_grid_config.siteNetworkCategoryFilters.length}}</span>
                        <v-icon>mdi-playlist-edit</v-icon>
                    </div>
                </div>
            </div>

            <div class="view-details-container view-details-alarm-filters" style="padding: 2px;">
                <span class="label">Alarm Filters</span>
                <v-simple-table dense style="background-color: #303030;" height="200px" fixed-header>
                    <thead>
                        <tr>
                            <th class="text-left" style="background-color: #303030;">Property</th>
                            <th class="text-left" style="background-color: #303030;">Enabled</th>
                            <th class="text-left" style="background-color: #303030;">Disabled</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td>Acked</td><td>{{selectedViewAlarmFiltersCounts.ackedEnabled}}</td><td>{{selectedViewAlarmFiltersCounts.ackedDisabled}}</td></tr>
                        <tr><td>Description</td><td>{{selectedViewAlarmFiltersCounts.descriptionEnabled}}</td><td>{{selectedViewAlarmFiltersCounts.descriptionDisabled}}</td></tr>
                        <tr><td>Local Time</td><td>{{selectedViewAlarmFiltersCounts.localTimeEnabled}}</td><td>{{selectedViewAlarmFiltersCounts.localTimeDisabled}}</td></tr>
                        <tr><td>Locale</td><td>{{selectedViewAlarmFiltersCounts.localeEnabled}}</td><td>{{selectedViewAlarmFiltersCounts.localeDisabled}}</td></tr>
                        <tr><td>Severity</td><td>{{selectedViewAlarmFiltersCounts.severityEnabled}}</td><td>{{selectedViewAlarmFiltersCounts.severityDisabled}}</td></tr>
                        <tr><td>Service Affecting</td><td>{{selectedViewAlarmFiltersCounts.serviceAffectingEnabled}}</td><td>{{selectedViewAlarmFiltersCounts.serviceAffectingDisabled}}</td></tr>
                        <tr><td>Time</td><td>{{selectedViewAlarmFiltersCounts.timeEnabled}}</td><td>{{selectedViewAlarmFiltersCounts.timeDisabled}}</td></tr>
                    </tbody>
                </v-simple-table>
            </div>

        </div>

        <div v-if="!selectedView">
            <span class="no-view-selected-text">Select a view from the libray</span>
        </div>

    </div>
    
</template>

<script>
export default {
    name: 'GeoMapSelectedViewDetails',
    props: ['selectedView', 'selectedViewClone', 'mapViews', 'googleMapStylesThumbnails', 'mapThemes', 'geoColors'],
    components: {

    },
    data: () => ({
        viewNameFormValid: true,
        validation: {
            required: (value, fieldName) => ((value || value === 0) ? true : false) || `${fieldName} is required`,
            unique: (value, views, userId) => (!value || !views.some(v => {return (v.user_id == userId && v.view_name == value.trim())})) || 'This View Name is already is use for this user. '
        },
        staticMapImgUrl: null
    }),

    computed: {
        userOwnsSelectedView: function() {
            if(!this.selectedView) {
                return false;
            }
            return this.selectedView.user_id == this.$store.state.user.user_id;
        },

        selectedViewAlarmFiltersCounts() {
            if(!this.selectedView) {
                return {};
            }
            return {
                ackedEnabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => f.enabled && f.property.value == 'alarm_acked').length,
                ackedDisabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => !f.enabled && f.property.value == 'alarm_acked').length,
                descriptionEnabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => f.enabled && f.property.value == '"alarm_description"').length,
                descriptionDisabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => !f.enabled && f.property.value == '"alarm_description"').length,
                localTimeEnabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => f.enabled && f.property.value == '"alarm_local_time"').length,
                localTimeDisabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => !f.enabled && f.property.value == '"alarm_local_time"').length,
                localeEnabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => f.enabled && f.property.value == '"site_locale"').length,
                localeDisabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => !f.enabled && f.property.value == '"site_locale"').length,
                severityEnabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => f.enabled && f.property.value == '"alarm_severity"').length,
                severityDisabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => !f.enabled && f.property.value == '"alarm_severity"').length,
                serviceAffectingEnabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => f.enabled && f.property.value == '"alarm_service_affecting"').length,
                serviceAffectingDisabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => !f.enabled && f.property.value == '"alarm_service_affecting"').length,
                timeEnabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => f.enabled && f.property.value == '"alarm_time"').length,
                timeDisabled: this.$props.selectedView.view_grid_config.advancedFilters.filter(f => !f.enabled && f.property.value == '"alarm_time"').length,
            };
        }

    },

    methods: {
        saveViewNameClick: function() {
            if(this.$refs.viewNameForm.validate()) {
                this.$emit('save');
            }
        },

        setStaticMapImgUrl: function() {
            console.log(this.$props.selectedView);
            let url = "";
            let apiKey = 'AIzaSyCT5eLcVMKyPSicy_5iEn8onYno7aHnAgQ';
            let mapType = 'roadmap';
            let lat = this.$props.selectedView.view_grid_config.map_coordinates.lat;
            let lng = this.$props.selectedView.view_grid_config.map_coordinates.lng;
            let center = `${lat},${lng}`;
            let zoom = this.$props.selectedView.view_grid_config.map_zoom;
            let size = '355x205';
            let scale = '2';
            url = `https://maps.googleapis.com/maps/api/staticmap?center=${center}&zoom=${zoom}&size=${size}&scale=${scale}&maptype=${mapType}&key=${apiKey}`;
            this.staticMapImgUrl = url;
        },
    },

    watch: {
        selectedView: {
            handler(newVal, oldVal) {
                console.log('selected View changed');
                this.setStaticMapImgUrl();
            }
        }
    },

    created() {
    },

    mounted() {
    }

  
};
</script>

<style scoped>

    .config-details-container {
        position: relative;
        margin-top: 1em;
        border-radius: 3px;
        border: rgba(255, 255, 255, 0.24) solid 1px !important;
        background-color: #303030 !important;
        height: 100%;
        padding: 20px;
    }

    .geomap-view-thumbnail-container {
        height: 100%;
        width: 100%;
        background-color: pink;
        display: inline-block;
        border: #000000 solid 1px;
    }

    .map-container {
        /* max-height: calc(100vh - 245px); */
        position: relative;
    }
    .map-container.empty {
        height: 100%;
    }
    .map-container img {
        height: 100%;
        width: 100%;
    }




    .config-name {
        display: inline-block;
        width: 100%;
        vertical-align: top;
    }

    .map-theme-image {
        border: gray solid 1px;   
        display: inline-block;
        width: 75px;
        height: 60px;
        margin-right: 1.5em;
    }
    .map-theme-text {
        font-size: 32px;
        position: absolute;
        top: 15px;
    }

    .view-details-container {
        position: relative;
        border-radius: 10px;
        border: gray solid 1px;
        /* width: 355px; */
        width: 345px;
        display: inline-block;
        margin-right: 10px;
        vertical-align: middle;
        height: 205px;
    }
    .view-details-container .label {
        display: block;
        position: absolute;
        background-color: #303030;
        z-index: 999999;
        top: -12px;
        left: 20px;
        padding-left: 3px;
        padding-right: 3px;
    }

    .view-details-site-filters .left-container {
        width: 70%;
        display: inline-block;
        height: 100%;
    }
    .view-details-site-filters .severity-container {
        width: 100%;
        height: 80px;
        padding: 20px 15px;
    }
    .view-details-site-filters .severity-container .type-label {
        font-size: 16px;
        display: block;
        margin-bottom: 5px;;
        text-decoration: underline;
    }
    .view-details-site-filters .severity-container i {
        font-size: 33px;
        margin-right: 3px;
    }
    .view-details-site-filters .severity-container i.disabled {
        opacity: 1;
    }

    .view-details-site-filters .right-container {
        width: 30%;
        display: inline-block;
        height: 100%;
        float: right;
    }


    .view-details-site-filters .count-container {
        text-align: center;
        width: 100%;
        height: calc(100% / 3);
        padding-top: calc(45px / 2);
    }
    .view-details-site-filters .count-container .count {
        font-size: 44px;
    }
    .view-details-site-filters .count-container i {
        font-size: 26px;
        vertical-align: sub;
    }


    .no-view-selected-text {
        font-size: 32px;
        text-align: center;
        color: rgba(255, 255, 255, 0.5);
        display: block;
        margin-left: -40px;
    }

</style>
